export default "__VITE_ASSET__dd470631__"